import { z } from 'zod';
import { expectType, zDocument, DocumentTypesLookup } from './model.js';
import { reverseKeys } from './util/reverseKeys.js';
export const NOTIFICATION_TYPES = [
    'userComment',
    'userPost',
    'userEvent',
    'system',
    'userReply',
    'popularPost',
    'moderateComment',
    'reviseComment',
    'upcomingEvent',
    'claimBusiness',
    'claimApproved',
    'claimDenied',
    'submitBusiness',
    'submitBusinessApproved',
    'submitBusinessRejected',
    'likePost',
    'likeComment'
];
const NotificationDocumentTypesLookup = {
    ...DocumentTypesLookup,
    none: 'None'
};
export const zNotificationDocumentType = z.nativeEnum(reverseKeys(NotificationDocumentTypesLookup));
export const zNotificationType = z.enum(NOTIFICATION_TYPES);
export const zNotification = zDocument.extend({
    type: z.literal('notification'),
    notificationType: zNotificationType,
    user: z.string(),
    notificationDocument: z.string(),
    notificationDocumentType: zNotificationDocumentType,
    notificationUser: z.string(),
    message: z.string(),
    rootDocument: z.string(),
    rootDocumentType: zNotificationDocumentType
});
expectType({});
expectType({});
export const EmptyNotification = {
    type: 'notification',
    notificationType: 'system',
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    notificationDocument: '',
    notificationDocumentType: 'none',
    notificationUser: '',
    message: '',
    user: '',
    rootDocument: '',
    rootDocumentType: 'none'
};
